/**
 * LP Monitor
 */
import { Api, ApiConfig } from '@shared/api';
import { I18n } from '@pc/components';
import './i18n';
import { getLocal } from '@shared/components/localStorage';

export default {
  name: 'LpMonitorModel',
  state: {
    lpNameOptions: [],
    lpName: '',
    lpAccountOptions: [],
    disabledLPAccount: true,
    lpAccount: '',
    userActivityOptions: [
      {
        key: 'login',
        text: I18n.t('lpMonitor:login'),
      },
      {
        key: 'download',
        text: I18n.t('lpMonitor:download'),
      },
    ],
    userActivity: '',
    dateRange: ['', ''],
    // tempKeyword: '',
    keyword: '',
    orderBy: {},
    data: [],
    pagination: {
      pageSize: 20,
      currentPage: 1,
    },
  },
  reducers: {
    update(state, payload) {
      return { ...state, ...payload };
    },
  },
  effects: {
    getParams(rootState) {
      const { lpName, lpAccount, userActivity, dateRange, keyword, orderBy } = rootState.LpMonitorModel;
      const newParams = {};
      lpName && Object.assign(newParams, { lp_name: lpName });
      lpAccount && Object.assign(newParams, { account: lpAccount });
      userActivity && Object.assign(newParams, { action: userActivity });
      dateRange[0] && Object.assign(newParams, { start_time: dateRange[0] });
      dateRange[1] && Object.assign(newParams, { end_time: dateRange[1] });
      keyword && Object.assign(newParams, { key: keyword });

      // {key1: 'desc', key2: 'asc'}
      // -> 'key1 desc,key2 asc'
      const order = Object.keys(orderBy)
        .map((key) => `${key} ${orderBy[key]}`)
        .join(',');
      order && Object.assign(newParams, { order_by: order });

      return newParams;
    },
    async getData(params, rootState) {
      const newParams = Object.assign({}, { ...params }, this.getParams(rootState));
      const response = await Api.request(ApiConfig.getLpMonitorLogs, newParams);
      this.update({
        data: response.rows,
        pagination: {
          currentPage: response.current_page,
          pageSize: response.page_size,
          total: response.total,
        },
      });
    },
    async getLPName(params) {
      // LP应该不会非常多，这里page_size设置大一点
      const newParams = Object.assign({}, { page_size: 100000 }, params);
      const response = await Api.request(ApiConfig.getAllUsers, newParams);
      this.update({
        lpNameOptions: response.rows,
      });
    },

    updateState(payload) {
      this.update(payload);
    },

    updateOrder(payload, rootState) {
      const { orderBy } = rootState.LpMonitorModel;
      const value = Object.values(payload)[0];
      const order = Object.assign({}, orderBy);
      if (value) {
        Object.assign(order, payload);
      } else {
        const key = Object.keys(payload)[0];
        delete order[key];
      }
      this.update({
        orderBy: order,
      });
    },

    setLPAccountOptions(data) {
      if (data) {
        this.update({
          lpName: data.lp_name,
          lpAccountOptions: data.lp_users,
          disabledLPAccount: false,
          lpAccount: '',
        });
      } else {
        this.update({
          lpName: '',
          lpAccountOptions: [],
          disabledLPAccount: true,
          lpAccount: '',
        });
      }
    },

    getExportLogsUrl(payload, rootState) {
      const params = this.getParams(rootState);
      let qs = Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
      const token = getLocal('TOKEN');
      token && qs.push(`auth_token=${token}`);
      qs = qs.join('&');
      return `/api/v1/users/monitor/file${qs ? `?${qs}` : ''}`;
    },
  },
};
